import Client from 'config/axios';
import posthog from 'posthog-js';

export const RejectPostRequest = async (id: number) => {
  const { data } = await Client.put(`/v1/employees/posts/${id}/reject`);
  return { data };
};

export const AcceptPostRequest = async (
  id: number,
  newContent: string,
  provider: string,
  token: string,
  tiktok: any = '',
  programmerPost: boolean,
  programmedDate: any = '',
  shareInFeed?: boolean,
  shareInStories?: boolean
) => {
  try {
    const content = {
      content: newContent,
      provider: provider,
      tiktok,
      programmed: programmerPost,
      programmedDate: programmedDate,
      configParticipation: {
        shareInFeed: shareInFeed,
        shareInStories: shareInStories
      }
    };
    const { data } = await Client.post(`publish-participation/${id}`, content, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('PublishParticipation', {
      UpdateGroup: data
    });
    return { data: data };
  } catch (response) {
    const result = response as any;
    return { errors: result.response?.data || result.data || result };
  }
};

export const discardBadPracticesParticipation = async (
  token: string,
  participationId: number,
  provider: string
) => {
  return await Client.post(
    `discard-bad-practices-participation`,
    { participationId, provider },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
    .then(response => response)
    .catch(error => error);
};

export const verifyTokenSocialNetwork = async (
  provider: string,
  token: string
) => {
  try {
    const { data } = await Client.get(
      `verify-token-social-network/${provider}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return { data: data };
  } catch (error: any) {
    throw new Error(error.response.data.data);
  }
};

// Redes vinculadas del embajador cuyo token venció o fue revocado.
export const getInvalidNetworks = async (token: string): Promise<string[]> => {
  const { data } = await Client.get('verify-token-social-network/all', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return data?.data?.invalidNetworks ?? [];
};

export const RestorePost = async (
  token: string,
  participationID: number,
  provider: string
) => {
  try {
    const { data } = await Client.post(
      `restore-participation/${participationID}?socialNetwork=${provider}`,
      '',
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return { data: data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
